import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import AOS from "aos";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "aos/dist/aos.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/jost";
import "@fontsource/ribeye-marrow";
import "@fontsource/lobster";
import "./assets/style/style.scss";
import { TopHeader } from "./components/headercomponents/TopHeder";
import { BottamHeader } from "./components/headercomponents/BottamHeader";
import { Footer } from "./components/footercomponents/Footer";
import { RouteData } from "./routes/routes";
import ScrollToTop from "./components/scrolltopcomponents/ScrollTop";
import TawkTo from "./components/chatcomponents/Message";
import Loader from "./components/loaderspinnercomponents/Loader";
import "animate.css";
import { CallAndWhatsapp } from "./components/callcomponents/Call";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { SITEMAP_API } from "./config/config";
import MobileFooter from "./components/footercomponents/MobileFooter";
import "lite-youtube-embed";

function App() {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 3000 });
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (location.pathname == "/") {
      localStorage.removeItem("city_name");
      localStorage.removeItem("country_name");
    }

    const hasVisited = sessionStorage.getItem("hasVisited");
    if (!hasVisited) {
      if (location.pathname !== "/") {
        setShowModal(true);
      } else {
        setTimeout(() => {
          setShowModal(true);
          sessionStorage.setItem("hasVisited", "true");
        }, 6000);
      }
    } else if (location.pathname === "/") {
      setShowModal(true);
    }
  }, [location, navigate]);

  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const response = await fetch(`${SITEMAP_API}`);
        if (!response.ok) {
          throw new Error("Failed to generate sitemap");
        }
      } catch (error) {
        console.error("Error generating sitemap:", error);
      }
    };

    fetchSitemap();
  }, []);

  useEffect(() => {
    const pathRegex = /^\/\d{4}\/\d{2}\/\d{2}\/(.+)/; // matches "/YYYY/MM/DD/slug"
    const match = location.pathname.match(pathRegex);

    if (match && match[1]) {
      const newPath = `/${match[1]}`; // new path without the date part
      navigate(newPath, { replace: true }); // redirect to cleaned URL
    }
  }, [location.pathname, navigate]);

  return (
    <>
      {/* {loading ? (
          <div className="d-flex justify-content-center align-items-center vh-100">
            <Loader />
          </div>
        ) : ( */}
      <div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <ScrollToTop />
        <CallAndWhatsapp />
        <TopHeader />
        <BottamHeader />
        <TawkTo />
        <MobileFooter />
        {/* <Routes>
          {RouteData?.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes> */}
        <Routes location={location} key={location.pathname}>
          {RouteData?.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          {/* Catch-all route for invalid URLs */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Footer />
      </div>
    </>
  );
}

export default App;
